import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import WalletCard from "../../components/RetailerBusinessAgent/WallertCard1";
import wallet1 from "../../images/shapes/Wallet01 5.png";
import wallet2 from "../../images/shapes/Wallet03.1 1.png";
import dollarG from "../../images/shapes/Dollar Bag.png";
import dollarY from "../../images/shapes/Dollar Bag (1).png";
import history1 from "../../images/shapes/Group 37483.png";


const CustomerCashbackDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [containerStyle, setContainerStyle] = useState({});
  const item = location.state?.item;

  useEffect(() => {
    if (!item) {
      // If accessed directly without state, redirect back to list
      navigate("/account-admin/requests");
    }
  }, [item, navigate]);

  if (!item) return null;

  return (
    <div style={{ ...containerStyle, height: "auto" }}>
       <div className="wallet-container1">
      <button 
        onClick={() => navigate("/account-admin/requests")}
        style={{
          background: "transparent",
          border: "none",
          color: "#001964",
          cursor: "pointer",
          marginBottom: "20px",
          display: "flex",
          alignItems: "center",
          gap: "5px",
          fontSize: "16px",
          fontWeight: "bold"
        }}
      >
        ← Back to Requests
      </button>

      <div style={{ background: "#fff", borderRadius: "12px", overflow: "hidden", boxShadow: "0 4px 15px rgba(0,0,0,0.1)", padding: "20px", marginBottom: "20px" }}>
        <h3 style={{ margin: "0 0 10px 0", color: "#333" }}>Customer Details</h3>
        <p><strong>Name:</strong> {item.customer?.first_name} {item.customer?.last_name}</p>
        <p><strong>Email:</strong> {item.customer?.email}</p>
      </div>

      <div className="">
        <WalletCard
          imgH={wallet2}
          imgT={dollarG}
          imgHi={history1}
          title="Captain TC Promotional Cash Wallet"
          amount={`£${item.promotional_wallet_gbp || "0.00"}`}
          subText="Eligible Value"
          bgColor="#f0fdf4"
          bgColor1="#dcfce7"
        />
        <WalletCard
          imgH={wallet1}
          imgT={dollarY}
          imgHi={history1}
          title="CaptainTC CollectibleCards Wallet"
          amount={`£${item.collectible_wallet_gbp || "0.00"}`}
          subText="Eligible Value"
          bgColor="#fffbeb"
          bgColor1="#fef3c7"
        />
        <WalletCard
          imgH={wallet1}
          imgT={dollarY}
          imgHi={history1}
          title="Issue CashBack Requested"
          amount={`${item.individual_pending_requests || 0} Requests`}
          subText="Pending Cashback Approvals"
          bgColor="#eff6ff"
          bgColor1="#dbeafe"
        />
      </div>
    </div>
    </div>
  );
};

export default CustomerCashbackDetails;
